module.exports = __webpack_public_path__ + "img/thumbnail_WildWaterBuffalo_f_albino.e07c2c8a.png";